module.exports = __webpack_public_path__ + "static/media/Header_CMP.e4f70566.jpg";